import get from 'lodash/get';
import React from 'react';
import { ContainerData, Item, Label, Wrapper } from './styled';

const SelectedWorkspaces = ({ data }) => {
  const workspaces = get(data, 'workspaces_commands', []);
  const isOdd = (n) => n % 2 !== 0;

  return (
    <Wrapper>
        <Label children='Workspaces' />
        <ContainerData showGradient={ workspaces?.length < 3 }>
          {workspaces?.map((item, i) =>
            <Item key={ i } isOdd={ isOdd(i) } children={ item?.workspace_name } />
          )}
        </ContainerData>
    </Wrapper>
  );
};

export default SelectedWorkspaces;
